import { MonitorCog, MonitorPlay, Shield, ShieldCheck, type LucideIcon } from 'lucide-react';
import type { ManagementCapability } from './types';

/**
 * Management-tier chip for the drawer header — vendored from scio3
 * `features/mdm-devices/utils/capability-display.ts` (English literal instead of an i18n key).
 * The icon encodes the tier too, so it is not a colour-only signal:
 *   utils-mdm    → Managed       (full OptiSigns agent control)
 *   builtin-mdm  → Built-in MDM  (OS-level management only)
 *   platform-api → Room system   (vendor API — Zoom/Teams/etc.)
 *   none         → Content only  (plays content, no device management)
 */
export interface CapabilityDisplay {
  label: string;
  Icon: LucideIcon;
}

export const CAPABILITY_DISPLAY: Record<ManagementCapability, CapabilityDisplay> = {
  'utils-mdm': { label: 'Managed', Icon: ShieldCheck },
  'builtin-mdm': { label: 'Built-in MDM', Icon: Shield },
  'platform-api': { label: 'Room system', Icon: MonitorCog },
  none: { label: 'Content only', Icon: MonitorPlay },
};

export function getCapabilityDisplay(cap: string | null | undefined): CapabilityDisplay {
  return CAPABILITY_DISPLAY[(cap ?? 'none') as ManagementCapability] ?? CAPABILITY_DISPLAY.none;
}
